import styled from 'styled-components'
import BaseModal from '../../../lib/modals/Modal'
import { tokens, Button } from '@arvoreeducacao/bonsai-ds'

export const Modal = styled(BaseModal)`
  width: 400px;
  border-radius: ${tokens.radius.xlarge};
  padding: 12px;
`

export const RightButton = styled(Button)`
  margin-left: auto;
`

export const Text = styled.div`
  font-size: ${tokens.fontSize.small};
  padding: 12px 0 32px 0;
`

export const Wrapper = styled.div`
  height: 172px;
  padding: 12px 0 32px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
